var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.level.name))]),_c('router-link',{staticClass:"button block-button",attrs:{"to":{ name: 'EditLevel', params: {levelID: _vm.level.id} }}},[_vm._v(" Look At ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }